import { render, staticRenderFns } from "./_expenseType.vue?vue&type=template&id=45a99d4b&scoped=true&"
import script from "./_expenseType.vue?vue&type=script&lang=js&"
export * from "./_expenseType.vue?vue&type=script&lang=js&"
import style0 from "./_expenseType.vue?vue&type=style&index=0&id=45a99d4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a99d4b",
  null
  
)

export default component.exports